<template>
  <v-card
    outlined
    class="px-6 pt-6"
  >
    <div class="d-flex flex-row justify-space-between align-center pb-3 ">
      <label class="subtitle-1 d-block grey--text">{{ pageTitle }}</label>
    </div>
    <v-menu
      v-model="menu.showPublishDate"
      transition="scale-transition"
      min-width="290px"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          outlined
          label="Date"
          prepend-inner-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          :value="publishedDate"
          :error-messages="errorMessages"
        ></v-text-field>
      </template>

      <v-date-picker
        :disabled="isDisabled"
        no-title
        scrollable
        v-model="publishedDate"
        @input="menu.showPublishDate = false"
      >
      </v-date-picker>
    </v-menu>

    <v-menu
      v-model="menu.showPublishTime"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      max-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          outlined
          label="Time"
          prepend-inner-icon="mdi-clock"
          readonly
          v-bind="attrs"
          v-on="on"
          :value="publishedTime"
        ></v-text-field>
      </template>
      <v-time-picker
        :disabled="isDisabled"
        min="01:01"
        format="24hr"
        full-width
        v-model="publishedTime"
        @click:minute="menu.showPublishTime = false"
      ></v-time-picker>
    </v-menu>
    <div v-if="!isDisabled" class="pb-4 d-flex flex-row-reverse">
      <v-btn
        x-small
        color="primary"
        text
        @click="setToCurrentDate"
      >Set to now</v-btn>
      <v-btn
        v-show="value !== null"
        x-small
        color="primary"
        text
        @click="clear"
      >Clear</v-btn>
    </div>
  </v-card>
</template>
<script>
import dayjs from 'dayjs'

export default {
  props: {
    value: {
      type: [String, Object],
      default: null
    },

    pageTitle: {
      type: String,
      default: 'Publish Date'
    },
    errorMessages: {
      type: [String, Array],
      default () {
        return null
      }
    },
    isDisabled: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      menu: {
        showPublishTime: false,
        showPublishDate: false
      }
    }
  },
  computed: {
    publishedDate: {
      get () {
        if (this.value) {
          return dayjs(this.value)
            .local()
            .format('YYYY-MM-DD')
        }
        return null
      },
      set (value) {
        this.$emit('input', dayjs(value))
      }
    },

    publishedTime: {
      get () {
        if (this.value) {
          return dayjs(this.value).format('HH:mm')
        }
        return null
      },
      set (value) {
        const [hours = 0, minutes = 0, seconds = 0] = value.split(':')
        let selectedDate = dayjs()

        if (this.value) {
          selectedDate = dayjs(this.value)
        }

        this.$emit('input', selectedDate
          .hour(hours)
          .minute(minutes)
          .second(seconds))
      }
    }
  },
  methods: {
    setToCurrentDate () {
      this.$emit('input', dayjs())
    },
    clear () {
      this.$emit('input', null)
    }
  }
}
</script>
